import Hero from "../components/Hero";
import hotelImg from "../assests/images/hotel-bg.jpg";
import {
    FaFileContract,
    FaUserCheck,
    FaCreditCard,
    FaBan,
    FaExclamationTriangle,
    FaGavel
} from "react-icons/fa";
import { FaPhoneAlt } from "react-icons/fa";

export default function TermsConditions() {
    return (
        <div className="w-full bg-gradient-to-b from-orange-50 to-white">

            {/* HERO */}
            <Hero
                variant="inner"
                title="Terms & Conditions"
                subtitle="Please read these terms carefully before using our services."
                backgroundImage={hotelImg}
            />

            {/* MAIN */}
            <div className="max-w-6xl mx-auto px-4 py-20 grid md:grid-cols-4 gap-10">

                {/* SIDEBAR */}
                <div className="md:col-span-1">
                    <div className="sticky top-24 bg-white rounded-2xl shadow-lg border border-orange-100 p-5 space-y-4">
                        <h3 className="font-semibold text-[#0F172A] mb-2">Quick Links</h3>

                        {[
                            "Introduction",
                            "User Responsibilities",
                            "Bookings & Payments",
                            "Cancellations",
                            "Prohibited Activities",
                            "Liability",
                            "Changes to Terms",
                            "Governing Law"
                        ].map((item, i) => (
                            <a
                                key={i}
                                href={`#section-${i}`}
                                className="block text-sm text-gray-600 hover:text-[#0F172A] transition"
                            >
                                {item}
                            </a>
                        ))}
                    </div>
                </div>

                {/* CONTENT */}
                <div className="md:col-span-3 space-y-8">

                    <div className="bg-white rounded-2xl shadow-xl border border-orange-100 p-8 space-y-10">

                        <Section
                            id="section-0"
                            icon={<FaFileContract />}
                            title="Introduction"
                            text="By accessing and using our website, you agree to comply with these Terms & Conditions. Please read them carefully before making any bookings."
                        />

                        <Section
                            id="section-1"
                            icon={<FaUserCheck />}
                            title="User Responsibilities"
                            list={[
                                "Provide accurate personal and booking information",
                                "Maintain confidentiality of your account",
                                "Use the website only for lawful purposes"
                            ]}
                        />

                        <Section
                            id="section-2"
                            icon={<FaCreditCard />}
                            title="Bookings & Payments"
                            text="All bookings are subject to availability. Payments must be completed through our secure payment system. Prices may vary based on availability and demand."
                        />

                        <Section
                            id="section-3"
                            icon={<FaBan />}
                            title="Cancellations & Refunds"
                            text="Cancellation policies vary depending on the hotel or service provider. Please review cancellation terms before confirming your booking."
                        />

                        <Section
                            id="section-4"
                            icon={<FaExclamationTriangle />}
                            title="Prohibited Activities"
                            list={[
                                "Fraudulent bookings or payments",
                                "Misuse of website services",
                                "Violating any applicable laws or regulations"
                            ]}
                        />

                        <Section
                            id="section-5"
                            icon={<FaGavel />}
                            title="Limitation of Liability"
                            text="We are not liable for any indirect, incidental, or consequential damages arising from the use of our services or third-party providers."
                        />

                        <Section
                            id="section-6"
                            icon={<FaFileContract />}
                            title="Changes to Terms"
                            text="We reserve the right to update these Terms & Conditions at any time. Continued use of the website implies acceptance of the updated terms."
                        />

                        <Section
                            id="section-7"
                            icon={<FaGavel />}
                            title="Governing Law"
                            text="These terms are governed by applicable local laws. Any disputes shall be resolved under the jurisdiction of the relevant authorities."
                        />

                        {/* CTA */}
                        <div className="bg-gradient-to-r from-[#0F172A] to-[#ff7a45] text-white rounded-xl p-6 text-center">
                            <h3 className="text-lg font-semibold mb-2">
                                Have questions about our terms?
                            </h3>
                            <p className="text-sm mb-4">
                                Our support team is here to help you anytime.
                            </p>

                            <a
                                href="tel:+971501234567"
                                className="inline-flex items-center gap-2 bg-white text-[#0F172A] px-5 py-2 rounded-lg font-medium hover:bg-orange-100 transition"
                            >
                                <FaPhoneAlt />
                                Call Support
                            </a>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}

/* Reusable Section Component */
function Section({ id, icon, title, text, list }) {
    return (
        <div id={id} className="scroll-mt-24">

            <div className="flex items-center gap-3 mb-3">
                <div className="text-[#0F172A] text-xl">{icon}</div>
                <h2 className="text-xl font-semibold text-[#0F172A]">
                    {title}
                </h2>
            </div>

            {text && (
                <p className="text-gray-600 text-sm leading-relaxed">
                    {text}
                </p>
            )}

            {list && (
                <ul className="list-disc pl-5 text-gray-600 text-sm space-y-1">
                    {list.map((item, i) => (
                        <li key={i}>{item}</li>
                    ))}
                </ul>
            )}
        </div>
    );
}